import type { CountryCode } from 'libphonenumber-js';

export type BaseAddress = {
  name?: string;
  phone?: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: CountryCode;
};

export type Address = Required<BaseAddress>;

export type CountryState = Pick<BaseAddress, 'country' | 'state'>;

export type SavedAddress = BaseAddress & {
  addressid: number;
  customerid: number;
  addresstype: 'S';
  isdefault: boolean;
  isactive: boolean;
  shippingmethodid: number | null;
  shippingnumber: string;
  shippinginstruction: string;
  usebillinginfo: boolean;
  lastmodifiedby: number | null;
  lastmodifieddate: string | null;
};

export type ValidationAPIInputAddress = {
  add1: string;
  add2: string | null;
  city: string | null;
  state: string | null;
  zip: string;
  country: CountryCode;
};

export type ValidationAPIOutputAddress = {
  changed: boolean;
  add1: string;
  add2: string | null;
  city: string;
  state: string;
  zip: string;
  country: CountryCode;
};

export type AddressValidationReturnValue = [Partial<BaseAddress>, boolean];

export type SmartyStreetCityState = {
  city: string;
  state_abbreviation: string;
  state: string;
};

export type SmartyStreetResponse = {
  input_index: number;
  input_id?: number;
  status?: 'blank' | 'invalid_state' | 'invalid_city' | 'invalid_zipcode' | 'conflict';
  city_states?: SmartyStreetCityState[];
};
